<template>
  <div id="thanks-banner" class="font-rubik flex flex-col min-w-0 min-h-0">
    <a id="close-thanks-banner"><img src="@/images/cookies/close.svg" alt="Close" @click="handleClose" /></a>
    <h4 id="thanks-header" class="mb-5">
      Thank You!<br>
      Your {{type == 'reservation' ? 'order was reserved' : 'quote was submitted'}}.
    </h4>
    <p>We've sent you an email with your reservation details to <b>{{ this.closedQuote.customer.email }}</b>.</p>
    <p>We will be following up to finalize your delivery details and schedule a date & time.</p>
    <p class="mb-5">If you have any questions or would like to modify your order please contact us.</p>


    <div class="flex md:justify-end flex-col-reverse md:flex-row text-center gap-4">
      <a
        href="/solutions/container-sales"
        class="underline text-[1rem] font-bold pt-3 md:mr-4 mb-2"
      >
        See Other Containers
      </a>


      <button
        v-if="paymentLink"
        @click="handlePayNow"
        class="border border-[#4D84FF] rounded-full h-[2.75rem] px-5 bg-[#4D84FF] text-white text-[1rem] w-full md:w-auto mb-2"
      >
        Pay Now
      </button>
  
      <button
        class="border border-[#4D84FF] rounded-full h-[2.75rem] px-5 bg-[#4D84FF] text-white text-[1rem] w-full md:w-auto mb-2"
        @click="handleClose"
      >
        Close Message
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import hasModal from 'shared/mixins/has-modal'

export default {
  mixins: [ hasModal ],
  props: {
    closeModal: {
      type: Function,
      default: () => true,
      required: false
    },
    type: String,
    closedQuote: {
      type: Object,
      default: () => {},
      required: false
    },
    paymentLink: {
      type: String,
      default: null,
      required: false
    }
  },
  computed: {
    ...mapState('quote', ['priceBook', 'quote']),
    showPrice () {
      if (this.priceBook.priceVisibility == 'private') {
        return false
      } else if (this.quote) {
        return this.quote.items.filter(item => item.priceBookEntry.priceVisibility == 'private').length == 0
      }
      return true
    }
  },
  async created () {
    await this['pricing.get']()
  },
  methods: {
    ...mapActions('quote', ['pricing.get']),
    handleClose () {
      this.closeModal()
      this.close()
    },
    handlePayNow() {
      if (this.paymentLink) {
        const newTab = window.open(this.paymentLink, '_blank')
        if (newTab) newTab.focus()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .thank-you-body {
    overflow: hidden;
  }

  #thanks-header {
    font-size: 24px;
    font-weight: 400;
  }

  #thanks-banner {
    position: fixed;
    font-size: 14px;
    right: 2rem;
    bottom: 2rem;
    max-width: 35rem;
    max-height: 100dvh;
    z-index: 1000;
    background-color: #F9F8F6;
    border: 1px solid #EDE9E3;
    border-radius: 0.5rem;
    padding: 2rem;
    box-shadow: 11px 7px 29px 0px #0000001A, 45px 30px 54px 0px #00000017, 
                100px 67px 72px 0px #0000000D, 178px 119px 86px 0px #00000003, 279px 185px 94px 0px #00000000;
  }

  #close-thanks-banner {
    position: absolute;
    top: -1.5625rem;
    right: 0.3125rem;
  }

  #thanks-banner p {
    margin-bottom: 12px;
  }

  @media(max-width: 1024px) {
    #thanks-banner {
      left: 2rem;
      right: 2rem;
      top: 50%;
      bottom: initial;
      transform: translateY(-50%);
      padding: 1.25rem;
      max-width: none;
    }
  }
</style>